
// Mock data for the gallery (in a real app, this would come from a database)
const BASE = import.meta.env.BASE_URL || "/";
const SAMPLE_IMAGE = `${BASE}lovable-uploads/4206a798-4c21-45ef-a749-16bb1bc65611.png`;
export const mockGalleryData = [
  {
    id: "1",
    title: "The Dragon's Secret",
    author: "J.R. Mitchell",
    imageUrl: SAMPLE_IMAGE,
    genre: "Fantasy",
    rating: 8,
    summary: "Strong imagery and clear genre signaling. Typography could use more contrast against the background.",
    fullCritique: "The cover successfully communicates a fantasy theme with its dragon imagery and mystical atmosphere. The typography is bold and eye-catching, though it could use more contrast against the detailed background for better readability. The color palette effectively conveys a sense of adventure and magic. The composition draws the reader's eye to the central dragon figure, creating a strong focal point.",
    suggestions: [
      "Increase contrast between text and background elements",
      "Consider adding a subtle glow effect around the title",
      "Experiment with a more dramatic lighting effect"
    ],
    submittedDate: "2023-08-12",
  },
  {
    id: "2",
    title: "Cold Case Files",
    author: "Miranda Lee",
    imageUrl: SAMPLE_IMAGE,
    genre: "Thriller",
    rating: 9,
    summary: "Excellent use of color and mood. Title treatment perfectly matches genre expectations.",
    fullCritique: "This cover excellently captures the essence of a thriller with its dark atmosphere and suspenseful imagery. The muted color palette creates an ominous mood that immediately signals the genre. Typography choices are spot-on, with a clean, authoritative font that remains legible even at thumbnail size. The visual hierarchy effectively guides the reader's eye from the striking image to the title and author name.",
    suggestions: [
      "Consider slightly increasing author name visibility",
      "The subtitle could be more prominent"
    ],
    submittedDate: "2023-08-14",
  },
  {
    id: "3",
    title: "Business Fundamentals",
    author: "Richard Stern",
    imageUrl: SAMPLE_IMAGE,
    genre: "Business",
    rating: 2,
    summary: "Unclear messaging and poor typography choices. Color scheme doesn't match business genre expectations.",
    fullCritique: "This cover fails to convey professionalism expected in the business genre. The typography lacks hierarchy, making it difficult to quickly understand the book's topic. The color scheme feels arbitrary rather than strategic, and doesn't align with standard business book conventions. The imagery appears generic and fails to communicate unique value proposition of the content.",
    suggestions: [
      "Redesign with a cleaner, more professional layout",
      "Use a more conventional business book color palette (blues, grays)",
      "Select typography that conveys authority and expertise",
      "Consider a more relevant and specific central image"
    ],
    submittedDate: "2023-08-10",
  },
  {
    id: "4",
    title: "Summer's End",
    author: "Emily Waters",
    imageUrl: SAMPLE_IMAGE,
    genre: "Romance",
    rating: 7,
    summary: "Good use of romantic imagery, though color choices could be more harmonious.",
    fullCritique: "The cover effectively signals the romance genre through its imagery and warm color palette. The emotional scene depicted creates immediate genre recognition. Typography is elegant and appropriate, though there are some minor issues with how the text elements interact with the background image. Color choices generally work well, though some hues compete rather than complement each other.",
    suggestions: [
      "Refine the color palette for better harmony",
      "Adjust text placement to improve legibility",
      "Consider a subtle vignette effect to improve text contrast"
    ],
    submittedDate: "2023-08-16",
  },
  {
    id: "5",
    title: "Quantum Theory",
    author: "Dr. Alan Zhang",
    imageUrl: SAMPLE_IMAGE,
    genre: "Science",
    rating: 3,
    summary: "Typography is difficult to read and imagery doesn't effectively communicate the subject matter.",
    fullCritique: "This cover struggles to convey the complex subject matter in an accessible way. The typography choices prioritize style over readability, making the title difficult to discern at a glance. The abstract imagery, while conceptually related to quantum physics, doesn't create clear subject recognition for the target audience. The color scheme feels random rather than purposeful in communicating the book's scientific nature.",
    suggestions: [
      "Redesign with clearer, more legible typography",
      "Use imagery that more directly signals 'science' to casual browsers",
      "Develop a more strategic color palette that feels contemporary and scholarly",
      "Consider adding a subtitle that clarifies the book's specific focus"
    ],
    submittedDate: "2023-08-15",
  },
  {
    id: "6",
    title: "Death's Door",
    author: "Samuel Black",
    imageUrl: SAMPLE_IMAGE,
    genre: "Horror",
    rating: 8,
    summary: "Excellent atmospheric elements and genre-appropriate typography. Minor issues with composition.",
    fullCritique: "The cover successfully creates an unsettling atmosphere that immediately signals the horror genre. Dark, moody imagery with strategic use of negative space builds tension and intrigue. Typography choices enhance the eerie feel with slightly distressed, angular fonts. The composition generally works well, though there are minor balance issues between visual elements.",
    suggestions: [
      "Adjust the visual weight distribution for better balance",
      "Consider enhancing the contrast in key areas to guide the eye",
      "Experiment with slightly more dramatic lighting effects"
    ],
    submittedDate: "2023-08-13",
  },
];

// List of genres for filtering
export const genres = [
  "All Genres",
  "Fantasy",
  "Science Fiction",
  "Romance",
  "Thriller",
  "Mystery",
  "Horror",
  "Business",
  "Self-Help",
  "Science",
  "Biography",
];
